import React, { useState } from 'react';
import { useCountdown } from './hooks/useCountdown';
import { useMetaPixel } from './hooks/useMetaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Audience } from './components/Audience';
import { SystemBand } from './components/SystemBand';
import { TomosAccordion } from './components/TomosAccordion';
import { BonosGrid } from './components/BonosGrid';
import { ComparisonTable } from './components/ComparisonTable';
import { UrgencyBand } from './components/UrgencyBand';
import { PricingCards } from './components/PricingCards';
import { EliteExtras } from './components/EliteExtras';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useMetaPixel('2069197916973057');
  const timeLeft = useCountdown(23, 44, 59);
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'elite'>('elite');
  return <div className="min-h-screen bg-[#0F172A] text-gray-100 font-body selection:bg-gold selection:text-dark" data-id="element-0">
      <TopBar timeLeft={timeLeft} data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Testimonials data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Audience data-id="element-6" />
        <SystemBand data-id="element-7" />
        <TomosAccordion data-id="element-8" />
        <BonosGrid data-id="element-9" />
        <ComparisonTable data-id="element-10" />
        <UrgencyBand timeLeft={timeLeft} data-id="element-11" />
        <PricingCards selected={selectedPlan} setSelected={setSelectedPlan} data-id="element-12" />
        <EliteExtras data-id="element-13" />
        <Guarantee data-id="element-14" />
        <FAQ data-id="element-15" />

        {/* Final CTA Repeat */}
        <div className="py-8 md:py-16 bg-[#0F172A] border-t border-gray-800" data-id="element-16">
          <div className="text-center mb-4 md:mb-8 px-4" data-id="element-17">
            <h2 className="font-display text-2xl md:text-4xl text-white mb-1 md:mb-2 uppercase" data-id="element-18">
              No dejes pasar esta oportunidad
            </h2>
            <p className="text-red-400 font-bold uppercase tracking-wider mb-2 md:mb-4 text-xs md:text-base" data-id="element-19">
              Termina en
            </p>
            <div className="flex justify-center gap-1.5 md:gap-2 text-2xl md:text-3xl font-display text-white" data-id="element-20">
              <span data-id="element-21">{timeLeft.hours.toString().padStart(2, '0')}</span>
              <span className="text-gray-500" data-id="element-22">:</span>
              <span data-id="element-23">{timeLeft.minutes.toString().padStart(2, '0')}</span>
              <span className="text-gray-500" data-id="element-24">:</span>
              <span className="text-gold" data-id="element-25">
                {timeLeft.seconds.toString().padStart(2, '0')}
              </span>
            </div>
          </div>
          <PricingCards selected={selectedPlan} setSelected={setSelectedPlan} data-id="element-26" />
        </div>
      </main>

      <Footer data-id="element-27" />
    </div>;
}